export class RescueEventType {

	static STEPS = {
		RESCUE_RESULT: 'RESCUE_RESULT'
	};

	static SEND = {
		RESCUE_SEND_RESULT: 'RESCUE_SEND_RESULT'
	};

	static ERROR = 'RESCUE_ERROR';
	static BUTTONS = 'RESCUE_BUTTONS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/rescue/rescue.event.type.ts